import { jsx as r } from "react/jsx-runtime";
import { useChatbotContext as m } from "../../hooks/useChatbotContext.js";
import n from "./HighlightedText.js";
function p({ children: a, ...t }) {
  const { chatbot: e, cn: o, search: s } = m();
  return /* @__PURE__ */ r(
    "li",
    {
      ...t,
      "data-testid": "user-message",
      className: o(
        "mb-2 flex animate-fadeIn items-center self-end rounded-large rounded-tr-none bg-primary px-4 py-3 text-base leading-[1.5] text-primary-foreground shadow shadow-primary/10 drop-shadow-[0_15px_25px_rgba(0,0,0,0.02)] @notMobile:text-[14.5px] min-[409px]:max-[409px]:text-[14.5px]",
        {
          "ml-5 @notMobile:ml-10": !(e != null && e.avatarUrl),
          "ml-5 @notMobile:ml-20": e == null ? void 0 : e.avatarUrl
        },
        t.className
      ),
      children: /* @__PURE__ */ r(
        "p",
        {
          className: "whitespace-pre-line break-words",
          style: { wordBreak: "break-word" },
          children: s ? /* @__PURE__ */ r(n, { searchTerm: s, children: a }) : a
        }
      )
    }
  );
}
export {
  p as UserMessage
};
